import { STATUS } from "~constants/status"

interface TableLink {
  href: string
  templated?: boolean
}

export interface TablePaginatorShape {
  size: number
  number: number
  totalPages: number
  totalElements: number
}

export const paginatorInitState: TablePaginatorShape = {
  size: 0,
  number: 0,
  totalPages: 0,
  totalElements: 0,
}

export interface TableResponseShape {
  page: TablePaginatorShape
  _embedded: any
  _links: {
    first: TableLink
    last: TableLink
    next: TableLink
    search: TableLink
    self: TableLink
  }
}

export interface TableOptionsShape {
  page?: number
  size?: number
  sort?: string
  status?: STATUS
  email?: string
  id?: string
}
